<template>
  <div>
    <h1 class="mb-3">CitSci Terms of Use and Privacy Policy</h1>
    <Terms></Terms>
    <Privacy></Privacy>
  </div>
</template>

<script>
import Terms from './Terms.vue'
import Privacy from './Privacy.vue'

export default {
  components: {
    Terms,
    Privacy,
  }
}
</script>

<style scoped lang="scss">

</style>
